import { getCode } from '../../modules/get_code'
import countries from '../../json/countries.json'

// カード裏面用データの構築
export function buildPlayerDetailDatas (detailDatas) {
  return detailDatas.map(detailData => {
    const playerData = {
      id: detailData.id,
      name_jp: (detailData.last_name_jp && detailData.first_name_jp) ? `${detailData.last_name_jp} ${detailData.first_name_jp}` : null,
      name_en: `${detailData.last_name_en}<br>${detailData.first_name_en}`,
      birthday: generateValue(detailData.birthday, '', '', (txt) => txt.replace(/-/g, '.')),
      age: generateValue(funcCalcAgeString(detailData.birthday), '', 'ー歳'),
      height: generateValue(detailData.height, 'cm'),
      weight: generateValue(detailData.weight, 'kg'),
      country_code: generateValue(detailData.country_code, '', ''),
      country: generateValue(detailData.country_code, '', '', (key) => countries[key].code3.toUpperCase()),
      catchphrase: generateValue(detailData.catchphrase, '', ''),
      year_best: generateValue(detailData.year_best),
      round_best: generateValue(detailData.round_best),
      winner: generateWinnerTxt(detailData.first_count, detailData.winner_rate),
      first_place_count: generateValue(detailData.first_place_count, '回'),
      title: (() => {
        const pist6TitleArr = detailData.pist6_title ? detailData.pist6_title.split(/,|、|，|\//) : [];
        const majorTitleArr = detailData.major_title ? detailData.major_title.split(/,|、|，|\//) : [];
        return generateValue([...pist6TitleArr, ...majorTitleArr].slice(0, 2).join('<br>'));
      })(),
      grades_latest: (() => {
        const gradesLatestData = (() => {
          if (detailData.round_result_list && detailData.round_result_list.length >= 1) {
            return detailData.round_result_list[0];
          } else if (detailData.round_result && Object.keys(detailData.round_result).length != 0) {
            return detailData.round_result;
          }
          return null
        })()
        return gradesLatestData
          ? generateGradesTxt(gradesLatestData)
          : 'ー';
      })()
    };

    const evaluations = ['evaluation', 'speed', 'stamina', 'power', 'technique', 'mental'];
    const isCompleteEvaluation = evaluations.filter(key => detailData[key]).length == evaluations.length;
    playerData['isCompleteEvaluation'] = isCompleteEvaluation;
    evaluations.forEach(key => {
      if (key == 'evaluation') {
        playerData.evaluation = generateValue(detailData[key], '', '-');
      } else {
        playerData[key] = {
          num: generateValue(detailData[key]),
          bar: generateValue(detailData[key], '%', '')
        }
      }
    });

    return playerData;
  });
}

// 過去ラウンド成績テキストの生成
const generateGradesTxt = (data) => {
  console.log(data);
  const necessaryKeys = ['event_date', 'season', 'round_code', 'tt_rank', 'race_list'];
  const isCompleteGrades = necessaryKeys.filter(key => data[key]).length == necessaryKeys.length;
  if (isCompleteGrades) {
    const dateSuffixs = ['年', '月', '日'];
    const raceDate = data.event_date.split('-').map((value, idx) => {
      return `${value}${dateSuffixs[idx]}`;
    }).join('');
    const seasonText = getCode('seasonText', data.season).ja;
    const roundText = getCode('round', data.round_code).name;
    const raceResultTexts = data.race_list.map(raceResult => {
      return `${getCode('raceDetail', raceResult.details_code).name} ${raceResult.race_rank}着`;
    });
    return [
        `${raceDate}&emsp;${seasonText}&emsp;${roundText}`,
        `タイムトライアル${data.tt_rank}位`,
        `${raceResultTexts.join('&emsp;')}`
      ].join('<br>');
  }
  return 'ー';
}

// 勝利数/勝率テキスト生成
const generateWinnerTxt = (firstCount, winnerRate) => {
  const firstCountTxt = generateValue(firstCount, '回');
  const winnerRatetTxt = generateValue(winnerRate, '%');
  return `${firstCountTxt} / ${winnerRatetTxt}`;
}

// データ成形
const generateValue = (val, unit = '', nodata = 'ー', func = null) => {
  return val
    ? (() => {
        const txt = `${val}${unit}`
        if (func) {
          return func(txt);
        }
        return txt;
      })()
    : nodata;
}


// 年齢計算
const funcCalcAgeString = (birthData, unit = '歳') => {
  if (birthData) {
    const birthArr = birthData.split(/-|\./);
    const dateObj = new Date();
    const currentYear = dateObj.getFullYear();
    const currentMonth = `0${dateObj.getMonth() + 1}`.slice(-2);
    const currentDay = `0${dateObj.getDate()}`.slice(-2);
    return (currentYear - (Number(birthArr[0]) + 1)) + ( currentMonth + '' + currentDay < birthArr[1] + birthArr[2] ? 0 : 1) + unit;
  }
  return null
}
export function calcAgeString (birthData, unit = '歳') {
  return funcCalcAgeString(birthData, unit)
}
